(function () {
  if (window.__jvCartRecommendationsInited) return;
  window.__jvCartRecommendationsInited = true;

  document.addEventListener(
    'submit',
    async function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('[data-jv-cr-form]')) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]') || form.querySelector('.jv-cr__add');
      var originalLabel = btn ? btn.textContent.trim() : '+ Adaugă';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Se adaugă…';
      }

      var fd = new FormData(form);

      try {
        var addUrl =
          (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add';

        var addResp = await fetch(addUrl, {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
        });
        var addData = await addResp.json();

        if (addData && addData.status && addData.status >= 400) {
          throw new Error(addData.message || 'Cart add failed');
        }

        var cartResp = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        var cart = await cartResp.json();

        // Dispatch cart:update WITHOUT `sections` in detail.
        // cart-items-component falls back to sectionRenderer.renderSection(sectionId, {cache:false})
        // which fetches via SFR (response wrapped in <div id="shopify-section-X">) and morphs.
        var evt = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'jv-cart-recommendations',
            data: {
              source: 'jv-cart-recommendations',
              itemCount: cart.item_count,
              productId: addData.product_id ? String(addData.product_id) : undefined,
              variantId: fd.get('id') ? String(fd.get('id')) : undefined
            }
          }
        });
        document.dispatchEvent(evt);

        // After full-mode morph the drawer scroll resets to top.
        // Scroll the summary into view so user immediately sees: updated FSB + total + checkout.
        scrollDrawerToSummary();

        if (btn) {
          btn.textContent = '✓ Adăugat';
          setTimeout(function () {
            btn.textContent = originalLabel;
            btn.disabled = false;
          }, 1500);
        }
      } catch (err) {
        console.error('[jv-cr] error', err);
        if (btn) {
          btn.textContent = originalLabel;
          btn.disabled = false;
        }
      }
    },
    true
  );

  function scrollDrawerToSummary() {
    var attempts = 0;
    var maxAttempts = 8;
    var interval = setInterval(function () {
      attempts++;
      var dialog = document.querySelector('cart-drawer-component dialog[open]');
      if (!dialog) {
        if (attempts >= maxAttempts) clearInterval(interval);
        return;
      }
      // Prefer summary block; fallback to bottom of scroll container.
      var summary = dialog.querySelector('.cart-drawer__summary');
      var scroller = dialog.querySelector('.cart-drawer__content');
      if (summary && typeof summary.scrollIntoView === 'function') {
        try {
          summary.scrollIntoView({ behavior: 'smooth', block: 'end' });
        } catch (e) {
          if (scroller) scroller.scrollTop = scroller.scrollHeight;
        }
        clearInterval(interval);
        return;
      }
      if (scroller) {
        scroller.scrollTop = scroller.scrollHeight;
        clearInterval(interval);
        return;
      }
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 80);
  }
})();
